import {
  take,
  put,
  fork,
  cancel,
  cancelled,
  select,
  actionChannel,
} from "redux-saga/effects"

import devlog from "src/helpers/devlog"
import { request } from "src/engine/modules/session/effects"
import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import { types, creators } from "../actions"
import { process as selectProcess } from "../selectors"
import { normalize } from "../helpers"

export function* read(action) {
  const { id, model } = action

  try {
    const { getUrl, getRestUrn } = normalizeModel(model)

    const requestURL = getRestUrn ? getRestUrn(`get`, id) : getUrl(id) // TODO: remove getUrl support

    const { data } = yield request(requestURL)
    // #model
    const normalized = normalize(data, model)
    yield put(creators.read.success(model, id, normalized.data))
  } catch (error) {
    devlog(error)
    yield put(creators.read.error(model, id, error))
  } finally {
    if (yield cancelled()) {
      yield put(creators.read.cancel(model, id))
    }
  }
}

export default function* fetchSaga() {
  const fetchRequest = yield actionChannel([types.read, types.readCancel])
  while (true) {
    const action = yield take(fetchRequest)

    const { id, model } = action

    const process = yield select(selectProcess, model, id)

    if (action.type === types.read) {
      // Detect current action is works
      if (process) {
        switch (process.type) {
          // Ignore, if it's already fetching
          // Ignore, if it's updating
          // Ignore, if it's crating
          case types.read:
          case types.update:
          case types.create:
          case types.remove:
            return
          default:
            throw new Error(`Unknown entity action type founded`)
        }
      }
      const task = yield fork(read, action)
      yield put(creators.processing.start(types.read, task, model, id))
      yield fork(function* watchFork() {
        yield task.toPromise()
        yield put(creators.processing.complete(types.read, task, model, id))
      })
      // If fetch completed, we should erase existen progress
    } else if (action.type === types.readCancel) {
      if (process) {
        const { task } = process
        if (process.type === types.read) {
          yield cancel(task)
        } else {
          throw new Error(
            `Unexpected cancellation of process with another task`,
          )
        }
      }
    }
  }
}
